<template>
  <div></div>
</template>

<script>
export default {
  name: 'FollowSearch',
  beforeMount () {
    let filters = JSON.stringify({'newDocs': 'new'})
    let search = this.$route.params.search
    let queryParams = {
      typeSearched: this.$route.query.typeSearched,
      filters
    }

    if (typeof this.$route.query.projectId !== 'undefined' && typeof this.$route.query.listId !== 'undefined') {
      localStorage.setItem('listIdSelected', this.$route.query.listId)
      localStorage.setItem('projectSelected', this.$route.query.projectId)
    } else {
      localStorage.removeItem('listIdSelected')
      localStorage.removeItem('projectSelected')
    }

    this.$router.replace({name: 'Search', params: {query: search}, query: queryParams})
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/follow/Search.vue